<template>
	<div id="org__request__filter__wrap">
		<div class="container-wrapper search-row-container-wrapper" id="org-request-filters-container">
			<div class="search-row-container container wide">
				<div class="search-row">
					<div class="search-row__search-bar search-bar-col">
						<b-input-group>
							<b-form-input class="input-search" placeholder="Search..." v-model="globalSearch" v-on:keyup.enter="searchGlobal"/>
							<b-input-group-append class="vdp-datepicker__search-button">
								<button type="button" class="btn" @click="searchGlobal()"><i class="icon-search"></i></button>
							</b-input-group-append>
							<b-input-group-append class="vdp-datepicker__clear-button" v-if="globalSearch">
								<button type="button" class="btn" @click="clearSearch();searchGlobal()">&times;</button>
							</b-input-group-append>
						</b-input-group>
					</div>
					<div class="search-row__filter-button d-flex hide-mobile">
						<div class="advance-search-filter" @click="toggleAdvancedSearch">
							<img src="/img/nav/icon-filter-dark-reverse.svg" alt="filter"  v-if="hasAdvancedFilters()" /><img src="/img/nav/icon-filter-dark.svg" alt="filter"  v-if="!hasAdvancedFilters()"/><span v-if="advancedFilterCount()"> {{ advancedFilterCount() }}</span> FILTERS <span class="badge badge-secondary" v-if="1 == 2 && hasAdvancedFilters()" v-html="advancedFilterCount()"></span> <img src="../assets/downarrow.svg" alt="downarrow"
							:class="{'advance-arrow': true, 'up': showAdvancedSearch}" />
						</div>
						<button type="button" class="hide-mobile btn search-row__filter-clear-button"     v-if="hasAdvancedFilters()" @click="resetArgs()">
							&times;<span v-html="resetText"></span>
						</button>

					</div>
				</div>
			</div>
			<h1 class="page-title mobile-only">Organization Requests</h1>
		</div>
		<div class="container-wrapper advance-search-container-wrapper" :class="{'expanded-wrapper': showAdvancedSearch}">
			<div id="advance-search" :class="{'expanded': showAdvancedSearch, 'container':true, 'wide':true,'advance-search-container':true}">
				<b-collapse :visible="showAdvancedSearch" class="advance-search-expandable">
					<b-row>
						<b-col lg="auto" md="auto" sm="auto">
							<b-form-group
							label="Approval Status"
							label-size="sm"
							:label-for="`org-request-status`"
							>
							<b-form-select :id="`org-request-status`" :options="approvedOptions"
							v-model="filterApproved.value"
							@input="toggleApproved();filterApproved.resetStatus()"
							:state="filterApproved.status"
							@change="toggleApproved"
							>
						</b-form-select>
					</b-form-group>
				</b-col>
				<b-col v-if="$store.state.isMobile" class="sorting-option">
					<b-form-group
						label="Sort"
						label-size="sm"
						label-cols="auto"
						content-cols="auto"
						label-for="fs-filter-sort-by"
					>
						<b-form-select
							id="org-request-filter-sort-by"
							:options="OrganizationRequest.getSortOptions"
							@input="filterSortBy.resetStatus()"
							:state="filterSortBy.status"
							v-model="filterSortBy.value"
							@change="sortByChange"
						/>
					</b-form-group>
				</b-col>
				<b-col lg="auto" md="auto">
					<b-form-group
					label="Date Submitted"
					label-size="sm"
					:label-for="`user-filter-from-date`"
					>
					<div class="dates">
						<date-range-picker single-date-picker="range"
                            v-model="filterDate"
                            show-dropdowns
                            :opens="$store.state.isMobile ? 'center' : 'right'"
                            @update="onDateRangeSelect"
                            :ranges="dateRangePickerRanges"
                            :auto-apply="true"
							:append-to-body="$store.state.isMobile"
                        >
                        <template v-slot:input="picker" style="min-width: 350px;">
                            <span v-if="picker.startDate && picker.endDate" v-html="formatDateRange(picker.startDate,picker.endDate)">
                            </span>
                            <span v-else>Start/End Date</span>
                        </template>
                      </date-range-picker>
					</div>
				</b-form-group>
			</b-col>
			<b-col id="search-col">
				<div class="search-col__button-wrapper d-flex">
					<b-button id="search-btn" size="sm" @click="setArgs">Search</b-button>
					<b-button class="ml-3" variant="danger" id="reset-filter" @click="resetArgs" v-if="hasAdvancedFilters() && $store.state.isMobile"> Reset</b-button>
				</div>
			</b-col>
		</b-row>
	</b-collapse>
</div>

</div>
<div class="quick-switch-container-wrapper">
	<div class="quick-switch-container container wide hide-mobile">
		<div class="quick-switch hide-mobile">
			<div class="quick-switch__title-standalone" v-html="title"></div>
			<div class="quick-switch__sort-by">
				<b-form-group
					label="Sort"
					label-size="sm"
					label-cols="auto"
					content-cols="auto"
					label-for="fs-filter-sort-by"
				>
					<b-form-select
						id="org-request-filter-sort-by"
						:options="OrganizationRequest.getSortOptions"
						@input="filterSortBy.resetStatus()"
						:state="filterSortBy.status"
						v-model="filterSortBy.value"
						@change="sortByChange"
					/>
				</b-form-group>
			</div>
		</div>
	</div>
</div>
</div>
</template>

<script>
import Vue from 'vue'
import OrganizationRequest from './../models/OrganizationRequest'
import BootstrapField from './../utility/BootstrapField';
import Format from './../utility/Format';
import moment from 'moment-timezone';

export default {
	name: 'OrganizationRequestFilters',
	components:{
	},
	props: {
		columns: Array,
		totals: Object,
		activeList: Number,
		callOptionMethod: String,

		storeArgs:String,
		storeModule:String,

	},
	data: () => ({
		showAdvancedSearch: false,
		showLaneFilter: false,
		arg: {},
		globalSearch: null,
		OrganizationRequest,
		approvedOptions: [{value: 2, text: "All"}].concat(OrganizationRequest.getIsApprovedOptions),

		filterApproved: new BootstrapField({
			value: null,
		}),
		userOrganizationValue: null,
		filterDate: {
			startDate: null,
			endDate: null,
		},
		filterSortBy: new BootstrapField({
			value: 'name asc'
		}),
	}),
	mounted() {
		Vue.prototype.$bus.$emit('menu:hasAdvanceFiltersState', this.hasAdvancedFilters());
		Vue.prototype.$bus.$emit('menu:advanceFiltersCount', this.advancedFilterCount());
		this.getAdvancedSearch();
		this.setArgs();
	},
	created() {
		Vue.prototype.$bus.$off('menu:toggleUserAdvanceFilter', this.toggleAdvancedSearch);
		Vue.prototype.$bus.$on('menu:toggleUserAdvanceFilter', this.toggleAdvancedSearch);
		if ( this.columns ) {
			this.columns.forEach(item => {
				if ( item.filter ) {
					if ( item.filter.autoComplete && item.filter.show ) {
						this.getArgs(item.filter)

					}
				}
			})
		}
	},

	computed: {
		resetText() {
		    if (this.advancedFilterCount() == 1) {
		      return "Reset " + this.advancedFilterCount() + " filter";
		    } else {
		      return "Reset " + this.advancedFilterCount() + " filters";
		    }
		},

		title() {
			if (this.filterApproved.value == null) {
				return "Pending Organization Requests";
			}
			if (this.filterApproved.value == 1) {
				return "Approved Organization Requests";
			}
			if (this.filterApproved.value == 0) {
				return "Rejected Organization Requests";
			}
			if (this.filterApproved.value == 2) {
				return "All Organization Requests";
			}
			return "Organization Requests";
		},
		Totals() {
			let lists = []
			for (let item in this.totals) {
				if (item == "closures") {
					let attr = [],
					total = 0
					for (let key in this.totals[item]) {
						attr.push({
							name: key,
							count: parseInt(this.totals[item][key])
						})
						total += parseInt(this.totals[item][key])
					}
					lists.push({
						taskName: item,
						total,
						status: attr
					})
				}
			}
			return lists
		},
		dateRangePickerRanges() {
			return Format.getLocalDatePickerRanges();
        }
	},
	methods: {
		hasAdvancedFilters() {
			let response = false;
			for (let item in this.arg) {
				if (this.arg[item] != null && item != "fromDate" && item != "toDate" && item != "sortBy" && item != "sortOrder") {
					response = true;
				}
			}
			if (this.filterDate.startDate || this.filterDate.endDate) {
                if (this.filterDate.startDate != "Invalid Date" && this.filterDate.endDate != "Invalid Date") {
                    response = true;
                }
            }
			Vue.prototype.$bus.$emit('menu:hasAdvanceFiltersState', response);
			return response;
		},

		advancedFilterCount() {
			let count = 0;
			for (let item in this.arg && item != "fromDate" && item != "toDate" && item != "sortBy" && item != "sortOrder") {
				if (this.arg[item] != null) {
					count++;
				}
			}
			if (this.filterDate.startDate || this.filterDate.endDate) {
                if (this.filterDate.startDate != "Invalid Date" && this.filterDate.endDate != "Invalid Date") {
                    count++;
                }
            }
			Vue.prototype.$bus.$emit('menu:advanceFiltersCount', count);
			return count;
		},
		handleAutocomplete(value, instanceId) {
			this.setArgs();
		},

		fieldId(name) {
			return this.storeArgs+"-field-"+name;
		},
		parseLabel(node, argAttr) {
			if ( node.label ) {
				if ( node.label.indexOf('(unknown)') > -1 ) {
					node.label = this.arg[argAttr]
				} else {
					this.arg[argAttr] = node.label
				}
			}
			return node.label
		},

		clickOutsideAdvanceSearch(e) {
			let filterBox = document.getElementById('org-request-filters-container');
			let advanceSearchBox = document.getElementById('advance-search');
			// console.log(advanceSearchBox);
			let keepOpen = false;
			if (advanceSearchBox) {
			  if (advanceSearchBox.contains(e.target)) {
			    keepOpen = true;
			  }
			}
			if (filterBox) {
			  if (filterBox.contains(e.target)) {
			    keepOpen = true;
			  }
			}
			if (!keepOpen) {
			  this.hideAdvanceSearch();
			}
		},
		toggleAdvancedSearch() {
		  this.showAdvancedSearch = !this.showAdvancedSearch
		  Vue.prototype.$bus.$emit('menu:advanceFiltersExpandedState', this.showAdvancedSearch);
		  this.saveAdvancedSearch();
		  if(!this.$store.state.isMobile) {
			  this.$nextTick(() => {
				if (this.showAdvancedSearch) {
				window.addEventListener('click', this.clickOutsideAdvanceSearch);
				}
				else {
				window.removeEventListener('click', this.clickOutsideAdvanceSearch);
				}
			});
		  }
		},

		hideAdvanceSearch() {
		  if (this.showAdvancedSearch) {
		    this.showAdvancedSearch = false;
		    window.removeEventListener('click', this.clickOutsideAdvanceSearch);
		  }
		},
		saveAdvancedSearch() {
			localStorage.setItem('showAdvancedSearch', this.showAdvancedSearch)
		},
		getAdvanceSearchColumnClasses(field) {
			return 'advance-search__'+field;
		},
		getAdvancedSearch() {
			this.showAdvancedSearch = false;
			/*
			let testValue = localStorage.getItem('showAdvancedSearch');
			if (testValue == "true") {
				this.showAdvancedSearch = true;
			} else {
				this.showAdvancedSearch = false;
			}
			*/
		},
		hasFilter() {
			return this.globalSearch != null ;
		},
		clearSearch() {
			this.globalSearch = null;
		},


		getOptionSelected(qty) {
			if (qty == 1) {
				return qty + " option selected";
			} else {
				return qty + " options selected"
			}
		},

		searchGlobal() {
			this.arg['keywords'] = this.globalSearch
			this.setArgs()
			this.$emit('submit:filters')
		},

		toggleApproved() {
			this.arg['isApproved'] = this.filterApproved.value;
		},

		clearArgs( filters ) {
			this.arg = {
				...this.arg,
				[filters.key]: null,
			}

		},
		getArgs( filters ) {
			let argQuery = JSON.parse(localStorage.getItem(this.storeArgs))
			if (argQuery == null) {
				argQuery = {};
			}

			// if ( this.arg === undefined )

			if ( filters.autoComplete ) {
				this.arg = {
					...this.arg,
					[filters.key]: argQuery[filters.key] != undefined ? argQuery[filters.key] : null,
				}
			} else if ( filters.datepicker ) {
				let startMoment = null;
				let endMoment = null;
				if (argQuery[filters.datepicker.from] != undefined) {
					startMoment = this.moment(argQuery[filters.datepicker.from]);
					if (startMoment.isValid()) {
					    startMoment.hours(0);
					    startMoment.minutes(0);
					    startMoment.seconds(0);
				this.arg = {
					...this.arg,
						    [filters.datepicker.from]: startMoment.format(),
						}
						this.filterDate.startDate = new Date(startMoment.format());
					} else {
						argQuery[filters.datepicker.from] = null;
						this.arg = {
						    ...this.arg,
						    [filters.datepicker.from]: null,
						}
						this.filterDate.startDate = null;
					}
				}
				if (argQuery[filters.datepicker.to] != undefined) {
					endMoment = this.moment(argQuery[filters.datepicker.to]);
					if (endMoment.isValid()) {
					    endMoment.hours(23);
					    endMoment.minutes(59);
					    endMoment.seconds(59);
					    this.arg = {
					        ...this.arg,
					        [filters.datepicker.to]: endMoment.format(),
					    }
					    this.filterDate.endDate = new Date(endMoment.format());
					} else {
						argQuery[filters.datepicker.to] = null;
						this.arg = {
						    ...this.arg,
						    [filters.datepicker.to]: null,
						}
						this.filterDate.endDate = null;
					}
				}
			}
			// pull in the global search and completed request filter.
			if (argQuery != null) {
				if (argQuery.keywords) {
					this.globalSearch = argQuery.keywords;
				} else {
					this.globalSearch = null;
				}

				if (typeof argQuery.isApproved != "undefined") {
					this.filterApproved.value = argQuery.isApproved;
				} else {
					this.filterApproved.value = null; // default to pending.
				}
				// pull in the data
				this.arg = argQuery;

				if (argQuery.sortOrder && argQuery.sortBy) {
                    this.filterSortBy.value = argQuery.sortBy + " " + argQuery.sortOrder;
                    this.arg['sortBy'] = argQuery.sortBy;
                    this.arg['sortOrder'] = argQuery.sortOrder;
                }
			}

		},
		setArgs() {
			this.showAdvancedSearch = false;
		  Vue.prototype.$bus.$emit('menu:advanceFiltersExpandedState', this.showAdvancedSearch);
			delete this.arg.status;
			delete this.arg.name;

			localStorage.setItem(this.storeArgs, JSON.stringify(this.arg))

			this.$emit('submit:filters')
		},
		resetArgs() {
			this.arg = Array()
			this.globalSearch = "";
			this.filterDate = { startDate: null, endDate: null };
			this.$store.dispatch(this.storeModule+'/clearParams');
			this.columns.map(elem => {
				if (elem.filter != undefined ) {
					if (elem.filter.show) {
						this.clearArgs(elem.filter)
					}
				}
			})
			this.setArgs()
			this.showAdvancedSearch = false
			Vue.prototype.$bus.$emit('menu:advanceFiltersExpandedState', this.showAdvancedSearch);
			Vue.prototype.$bus.$emit('menu:advanceFiltersCount', 0);
			this.saveAdvancedSearch();
		},

		onDatePickerChange(input, keyField) {
			let dateString = null;

				if (input) {
						let theDate = moment.tz({
								year: input.getFullYear(),
								month: input.getMonth(),
								day: input.getDate(),
								hour: keyField == "toDate" ? 23 : 0,
								minute: keyField == "toDate" ? 59 : 0,
								second: keyField == "toDate" ? 59 : 0
						}, Format.TIMEZONE);

			if (theDate.isValid()) {
								dateString = theDate.utc().format();
				}
			}

			this.arg = {
				...this.arg,
				[keyField]: dateString
			}



		},

		onDateRangeSelect(date) {
			const startDate = date.startDate;
			const endDate = date.endDate;

            this.arg = {
                ...this.arg,
				fromDate: startDate
					? Format.pickerDateToUtc(
						new Date(
							startDate.getFullYear(),
							startDate.getMonth(),
							startDate.getDate(),
							0, 0, 0
						)
					)
					: null,
				toDate: endDate
					? Format.pickerDateToUtc(
						new Date(
							endDate.getFullYear(),
							endDate.getMonth(),
							endDate.getDate(),
							23, 59, 59
						)
					)
					: null
			};

            // this.setArgs()
            // this.$emit('submit:filters')

		},

		formatDateRange(startDate,endDate) {
            let sd = this.$moment(startDate);
            let ed = this.$moment(endDate);
            return sd.format('MM/DD/YYYY') + " - " + ed.format('MM/DD/YYYY');
        },

		sortByChange(val) {
            if (val) {
                let vals = val.split(" ");
                this.arg['sortBy'] = vals[0];
                this.arg['sortOrder'] = vals[1];
            }
            else {
                this.arg['sortBy'] = this.arg['sortOrder'] = null;
            }
            this.setArgs();
            // this.$emit("submit:filters");
        },

        changeSortFromColumn(sortBy, sortOrder) {
            this.filterSortBy.value = sortBy + " " + sortOrder;
            this.sortByChange(this.filterSortBy.value);
        },
	}
}
</script>
